// extracted by mini-css-extract-plugin
export var promotionLink = "_un-0";